export enum AnswerSavingStatus {
  Saved = "Saved",
  InProgress = "InProgress",
  Editing = "Editing",
  Error = "Error",
}
